import React from "react";
import ModalApp from "components/ModalApp";
import PropTypes from "prop-types";

export function CouponRulesModal({ open, setOpen, couponRules }) {
  function handleOpenModal() {
    setOpen((prevState) => !prevState);
  }

  return (
    <ModalApp show={open} handleModal={handleOpenModal}>
      <div className="mx-4 d-flex align-items-center flex-column">
        <h3 className="text-center font-wl-600 text-mlg color-text-dark mb-5">
          Regras do cupom
        </h3>

        <div className="d-flex align-items-center flex-column gap-3 text-sm">
          <p style={{ textAlign: "justify" }}>{couponRules}</p>
        </div>

        <button
          className="btn-default-wl text-xxs p-2 fw-bold text-center mt-5 mb-3"
          style={{ width: 187 }}
          onClick={handleOpenModal}
        >
          FECHAR
        </button>
      </div>
    </ModalApp>
  );
}

CouponRulesModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  couponRules: PropTypes.string,
};
